import React from "react";
import { useHistory, Link } from "react-router-dom";
import { pathProfile, pathLogin, pathAddAccount } from "../../../config/vars";
import { validatePhoneRU } from "../../../functions";
import { loggedIn } from "../../../../pages/login/logics/reg";
import { getPhone, removeStorageData } from "../../../localStorage";
import { $SiteColors } from "../../../config/company-atts";

export const UserInfo = () => {
  const [showModal, setShowModal] = React.useState(false);
  const [phoneNumber, setPhoneNumber] = React.useState("");
  const userPhone = getPhone() || "";

  React.useEffect(() => {
    if (userPhone.length > 0 && loggedIn())
      setPhoneNumber(validatePhoneRU(userPhone).phone);
  }, [userPhone]);

  const history = useHistory();

  const userInfoClassName = `${
    showModal ? "user-info user-info_open" : "user-info"
  }`;

  const userNumberClassName = `${
    showModal ? "user-info__number user-info__number_open" : "user-info__number"
  }`;

  const userLogoFill = `${showModal ? $SiteColors.getState().headerDarkMenu : $SiteColors.getState().headerTextColor}`;

  function showHideModal() {
    setShowModal(!showModal);
  }
  const onOutClicked = () => {
    removeStorageData()
    //remUuidSession();
    setShowModal(false);
    history.push(pathLogin);
    localStorage.removeItem("idUser")
  };

  return (
    <div className={userInfoClassName}>
      <div className="user-info__data" onClick={showHideModal}>
        <div className="user-info__logo">
          <svg
            width="25"
            height="25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5 0C5.625 0 0 5.625 0 12.5S5.625 25 12.5 25 25 19.375 25 12.5 19.375 0 12.5 0zm0 3.75c2.125 0 3.75 1.625 3.75 3.75s-1.625 3.75-3.75 3.75S8.75 9.625 8.75 7.5s1.625-3.75 3.75-3.75zm0 17.75c-3.125 0-5.875-1.625-7.5-4 0-2.5 5-3.875 7.5-3.875S20 15 20 17.5c-1.625 2.375-4.375 4-7.5 4z"
              fill={userLogoFill}
            />
          </svg>
        </div>
        {phoneNumber && <p className={userNumberClassName} style={{color:userLogoFill}}>{phoneNumber}</p>}
      </div>
      <Link to={pathProfile}>
        <button
          type="button"
          className="user-info__button"
          onClick={showHideModal}
          style={{color: $SiteColors.getState().headerDarkMenu}}
        >
          Настройки
        </button>
      </Link>
      <Link to={pathAddAccount}>
        <button
          type="button"
          className="user-info__button"
          onClick={showHideModal}
          style={{color: $SiteColors.getState().headerDarkMenu}}
        >
          Добавить ЛС
        </button>
      </Link>
      <button
        type="button"
        className="user-info__button"
        onClick={onOutClicked}
        style={{color: $SiteColors.getState().headerDarkMenu}}
      >
        Выйти
      </button>
    </div>
  );
};
